import React, { useState, useEffect } from 'react';
import BsModal from '../Common/BsModal';
import ajaxGym from '../../util/remote/ajaxGym';
import functions from '../../util/functions';
import { useGym } from '../../DataStore/Gym/GymContext';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import TextInput from '../Common/TextInput';
import { useBalance } from '../../DataStore/BalanceContext';

const MembershipPaymentModal = ({ show, onClose, customer }) => {
  const { membershipTypeList, refreshSessions } = useGym();
  const { getCashBankListing, cashBankListing } = useBalance();
  const [selectedMembership, setSelectedMembership] = useState(customer?.membership_type || {});
  const [paymentAccount, setPaymentAccount] = useState("");
  const [reference, setReference] = useState('');
  const [amountPaid, setAmountPaid] = useState('');
  const [description, setDescription] = useState('');
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setSweetDialogInfo } = useTheme();

  useEffect(() => {
    getCashBankListing();
    setSelectedMembership(customer?.membership_type || {});
    setAmountPaid(customer?.membership_type?.standard_amount || '');
  }, [customer]);

  const handleMembershipChange = (membership) => {
    setSelectedMembership(membership);
    setAmountPaid(membership?.standard_amount || '');
  };

  const handlePayment = async () => {
    if (loading) return;
    if (!selectedMembership?.id) {
      setNotify(<Notification type='danger' message="Please select a membership type." />);
      return;
    }
    if (!paymentAccount && amountPaid > 0) {
      setNotify(<Notification type='danger' message="Please select a payment account." />);
      return;
    }

    setLoading(true);
    setNotify(null);

    const data = {
      member_id: customer?.id,
      membership_type_id: selectedMembership.id,
      payment_account: paymentAccount?.value,
      reference: reference,
      description: description,
      amount_paid: amountPaid
    }


    const server_response = await ajaxGym.payMembership(data);

    setLoading(false);
    if (server_response.status === "OK") {
      refreshSessions();
      setNotify(<Notification type='success' message={server_response.message} />);
      setSweetDialogInfo(server_response.message, customer.full_name + " has been successfully registered for " + selectedMembership.type_name, "success");
      onClose();
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }

    setTimeout(() => setNotify(null), 5000);
  };

  const RenderAccountField = () => {
    const options = [];
    if (Array.isArray(cashBankListing)) {
      cashBankListing.map((item, key) =>
        options.push({
          label: item.account_number + " " + item.account_name,
          value: item.account_id,
        })
      );
    }
    return (
      <TextInput
        label="Payment Account"
        type="select"
        leftIcon="fa fa-university"
        placeholder={paymentAccount.label || "Select account..."}
        options={options}
        onChange={(item) => setPaymentAccount(item)}
        leftComponent={<i className="fa fa-university" onClick={() => getCashBankListing(true)}></i>}
        loading={!cashBankListing}
      />
    );
  };

  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Membership Payment"
      size="modal-xl"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-success" onClick={handlePayment} disabled={!selectedMembership?.id}>
            <i className="fa fa-check mr-1"></i> Confirm Payment
          </button>
        </>
      }
    >
      <div className="row">
        <div className="col-md-6">
          <div className="mb-4">
            <h6 className="text-muted font-weight-bold mb-3">
              <i className="fa fa-user-circle mr-2 text-primary"></i>Customer Info
            </h6>
            <p className="mb-1 text-muted">
              <strong>Name:</strong> <span className="text-dark">{customer?.full_name}</span><br />
              <strong>Phone:</strong> <span className="text-dark">{customer?.phone_number}</span><br />
              <strong>Membership Expiry:</strong> <span className="text-dark">{customer?.membership_expiry ? functions.formatDate(customer.membership_expiry) : 'N.A'}</span>
            </p>
          </div>
          {notify}

          <div className="mb-4">
            <label className="font-weight-bold">
              <i className="fa fa-id-card text-primary mr-2"></i> Membership Type:
            </label>
            <div className="d-flex flex-wrap">
              {Array.isArray(membershipTypeList) && membershipTypeList.map((type) => (
                <div
                  key={type.id}
                  className={`p-3 m-2 rounded shadow-sm text-center membership-option ${selectedMembership?.id === type.id ? 'active' : ''}`}
                  onClick={() => handleMembershipChange(type)}
                >
                  <div className="font-weight-bold">{type.type_name}</div>
                  <div className={`text-${selectedMembership?.id === type.id ? 'light' : 'muted'}`}>UGX {functions.numberFormat(type.standard_amount)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
            <h5 className="text-center text-dark font-weight-bold mb-4">Payment Details</h5>
            <div className="mb-3">
              <strong>Total Bill:</strong> UGX {functions.numberFormat(selectedMembership?.standard_amount || 0)}<br />
              <strong>Total Paid:</strong> UGX {functions.numberFormat(amountPaid || 0)}
            </div>

            <TextInput
              type="number"
              label="Amount Paid"
              placeholder="Enter amount paid"
              leftIcon="fa fa-credit-card"
              value={amountPaid}
              onChange={e => setAmountPaid(e.target.value)}
              required
            />

            {RenderAccountField()}

            <TextInput
              type="text"
              label="Transaction Ref"
              placeholder="Transaction Ref"
              leftIcon="fa fa-hashtag"
              value={reference}
              onChange={e => setReference(e.target.value)}
              required
            />

            <TextInput
              type="textarea"
              label="Description"
              placeholder="Add any notes about the payment..."
              leftIcon="fa fa-list"
              value={description}
              onChange={e => setDescription(e.target.value)}
              required
            />
          </div>
        </div>
      </div>

    </BsModal>
  );
};

export default MembershipPaymentModal;
